var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass: "text-decoration-underline",
      on: {
        click: function ($event) {
          return _vm.openFeedbackModal()
        },
      },
    },
    [_vm._v("\n    Share your feedback\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }